<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
                <v-btn
                  outlined
                  small
                  fab
                  dark
                  class="transparent"
                  @click.stop="$router.go(-1)"
                 
                >
                  <v-icon>mdi-arrow-left-circle</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
               Activités
                <v-spacer></v-spacer>
              
               <v-btn
                  outlined
                  small
                  fab
                  dark
                  class="transparent"
                  @click.stop="$router.go(-1)"
                 
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-system-bar>
    <v-card-text>
      <template>
      <v-list>
        <v-list-item
          v-for="(item, index) in Activites"
          :key="index"
          class="project"
        >
         
          <v-list-item-content > 
             <v-list-item-title v-html="item.abbr_parcours"></v-list-item-title>
          <v-list-item-subtitle
            v-html="item.ll_parcours"
          ></v-list-item-subtitle>
          <div>Programme: {{item.ll_programme}}</div>
          <div>Thème: {{item.ll_theme}}</div>
            {{item.description_parcours}}


          </v-list-item-content>
        </v-list-item>
      </v-list>
      </template>
    </v-card-text>
    <v-card-actions>
      <Navigation :elements="AdminNavigation" v-if="user.isAdmin" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },

  created() {
    this.GetActivites();
    //this.importOnce();
  },

  methods: {
  /*      importOnce(){
      var self = this;
      let jsonFilePath = require("../../../traitements/t_parcours/t_parcours.json");
      Object.keys(jsonFilePath).forEach(function (item) {
        var elem = item;
        self.$firebase
          .firestore()
          .collection("activites")
          .doc(item)
          .set(jsonFilePath[item]);
      });
      console.log("vita ny Activites");
    }, */   

    ...mapActions({
      goBack: "Navigation/goBack",
      GetActivites: "Activites/GetAll",
    }),
  },
  computed: {
    ...mapState({
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
      Activites: (state) => state.Activites.Activites,
      user: (state) => state.Auth.user,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
